import apiCall from "../utils/api-call/apiCall";
import { createHeaders } from "./constants";

const saveApiKeyAndToken = async (body) => {
  const headers = createHeaders();
  return await apiCall('save-keys', 'POST', body, headers);
};

export { saveApiKeyAndToken };